// i18next bootstrap. Imported once for side effects from src/frontend.tsx
// before the React tree mounts so first paint already has translations
// available. Components consume via `useTranslation()` from
// `react-i18next`. Generated by step 005-i18n based on args.locales.
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			"en": { translation: en },
		},
		fallbackLng: "en",
		supportedLngs: ["en"],
		interpolation: { escapeValue: false },
	});

export default i18n;
